export default __webpack_public_path__ + "static/media/unload.d11b5bf4.svg";